require('expose-loader?RightSidebarApp!../../src/app/layout_apps/right_sidebar');
